import { jsx as p } from "react/jsx-runtime";
import { memo as r } from "react";
const t = r(({ children: m, ...o }) => /* @__PURE__ */ p("svg", { width: "20px", xmlns: "http://www.w3.org/2000/svg", ...o, children: m }));
t.displayName = "SvgWrapper";
export {
  t as Svg
};
//# sourceMappingURL=svg-wrapper.js.map
